import FundPageSkeleton from "./FundPageSkeleton";
import Skeleton from "./Skeleton";
import TableSkeleton from "./TableSkeleton";

export default Skeleton;

export { TableSkeleton, FundPageSkeleton, Skeleton };
